import BaseSingle from '@/containers/BaseSingle'

export default (module) => ({
  functional: true,
  components: {
    BaseSingle,
  },
  render (h, { props }) {
    return (
      <BaseSingle source={module} id={props.id} key={`${module}single`}/>
    )
  },
})
